import { Video, FileText, MessagesSquare, ClipboardCheck, ArrowRight } from "lucide-react";
import Reveal from "@/components/Reveal";

const STEPS = [
  {
    icon: Video,
    title: "Richiedi le informazioni",
    text: "Compili il modulo senza impegno: basta un minuto.",
    id: "richiedi",
  },
  {
    icon: FileText,
    title: "Invii referti ed esami",
    text: "Tutto quello che hai già fatto: ci aiuta a valutare.",
    id: "referti",
  },
  {
    icon: MessagesSquare,
    title: "Il medico valuta",
    text: "Se il consulto a distanza è appropriato o serve una visita in presenza.",
    id: "valuta",
  },
  {
    icon: ClipboardCheck,
    title: "Ricevi indicazioni chiare",
    text: "Come procedere, con calma e senza dubbi.",
    id: "indicazioni",
  },
];

export default function SecondOpinion() {
  const preset = () => {
    window.dispatchEvent(
      new CustomEvent("rdl:preset", {
        detail: { motivo: "Seconda opinione online", tipo: "Videoconsulenza" },
      })
    );
    document.querySelector("#prenota")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="secondaopinione" className="relative py-28 bg-card/30 border-y hairline overflow-hidden">
      <div className="absolute -top-24 -right-32 w-[460px] h-[460px] rounded-full bg-sagelight/15 blur-[130px]" />
      <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-14 items-center">
        <div>
          <Reveal>
            <p className="eyebrow">Seconda opinione online</p>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl mt-4 tracking-tight">
              Desideri una <span className="italic text-gold">seconda opinione?</span>
            </h2>
            <p className="mt-6 text-lg text-silver font-light leading-relaxed">
              Hai già effettuato visite o esami e desideri una seconda opinione? Puoi richiedere
              informazioni sulla consulenza online. Il medico valuterà se il consulto a distanza sia
              appropriato oppure se sia necessaria una visita in presenza.
            </p>
          </Reveal>

          <Reveal delay={0.1}>
            <button
              onClick={preset}
              data-testid="second-opinion-cta"
              className="group mt-8 inline-flex items-center gap-2 bg-gold text-ink font-semibold rounded-full px-7 py-3.5 hover:bg-goldlight transition-all hover:shadow-[0_0_36px_rgba(212,163,89,0.3)]"
            >
              Informazioni seconda opinione online
              <ArrowRight size={17} className="transition-transform group-hover:translate-x-1" />
            </button>
            <p className="text-[11px] uppercase tracking-[0.2em] text-silver/70 mt-3">
              Richiesta senza impegno · Valutazione caso per caso
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {STEPS.map(({ icon: Icon, title, text, id }, i) => (
            <Reveal key={id} delay={i * 0.07} className="h-full">
              <div
                className="relative h-full rounded-3xl border border-white/10 bg-elevated/60 p-6 transition-all duration-500 hover:border-gold/40"
                data-testid={`second-opinion-step-${id}`}
              >
                <span className="absolute top-5 right-5 font-mono-accent text-xs text-silver/50">
                  0{i + 1}
                </span>
                <span className="flex items-center justify-center w-11 h-11 rounded-2xl bg-sage/25 border border-sagelight/30 text-sagelight">
                  <Icon size={20} />
                </span>
                <h3 className="font-display text-xl mt-5 text-ivory">{title}</h3>
                <p className="text-sm text-silver leading-relaxed mt-2">{text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
